import { render, staticRenderFns } from "./SupplierMetalMaintain.vue?vue&type=template&id=7ec34896&scoped=true"
import script from "./SupplierMetalMaintain.vue?vue&type=script&lang=js"
export * from "./SupplierMetalMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec34896",
  null
  
)

export default component.exports